import React from 'react';
import Summary from './Summary';

const SummaryContainer = () => {
  return <Summary />;
};

export default SummaryContainer;
